
export default function ImageInput({ image, setImage, error, viewMode }) {
  return (
    <div className="relative ">
      <div
        className={`border h-[2.5rem] 
        ${
          error ? "border-[#ffa39e] border-1" : "border-[#E2E8F0] border-1"
        } px-4 py-2 text-gray-900 text-sm rounded-md focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40 px-2 py-1 flex justify-between items-center`}
      >
        <img
          src={!image ? '/images/gallery.png' : image}
          className="w-[24px] h-[24px] rounded"
        />
        <label className="block mb-0">
          <input
            type="file"
            onChange={setImage}
            disabled={viewMode}
            className="hidden w-full text-sm text-gray-500
      file:mr-4 file:py-2 file:px-4
      file:rounded-md file:border-0 opacity-0
      "
          />
          {
            <p className="text-blue font-medium text-[12px] tracking-[-.35px] text-blue-600 hover:text-blue-800 cursor-pointer mt-[14px]">
              Upload Logo
            </p>
          }
        </label>
      </div>
    </div>
  );
}
